import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Borre Haugen
 * id 85969E2D-500B-4565-8B80-A59FB6C8A73B
 * name floor-lamp-torchiere-variant
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-torchiere-variant.svg
 * tags
 * - Home Automation 
 */
export const FloorLampTorchiereVariantIcon = createSvgIcon(<><path d="M7 2L10 9H14L17 2H7M15.92 22L13 15V22H11V15L8.08 22H5.92L10.92 10H13.08L18.08 22H15.92Z" /></>, 'FloorLampTorchiereVariantIcon');
export default FloorLampTorchiereVariantIcon